import type { ReactNode } from "react";

/** Full-viewport centered column for pre-app screens: sign-in, loading, blocked. */
export function CenteredScreen({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-surface-base px-[max(1.5rem,env(safe-area-inset-left))] py-12">
      <div className="flex w-full max-w-md flex-col items-center gap-6 text-center">{children}</div>
    </main>
  );
}
